import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Cart } from '@spartacus/cart/base/root';
import { OccEndpointsService, Address } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DpCheckoutApiService {
  readonly #httpClient = inject(HttpClient);
  readonly #occEndpointService = inject(OccEndpointsService);

  addAddress(userId: string, address: Address): Observable<Address> {
    const url = this.#occEndpointService.buildUrl('addShipping', { urlParams: { userId } });
    return this.#httpClient.post<Address>(url, address).pipe(catchError((error: unknown) => throwError(() => error)));
  }

  updateDeliveryAddress(userId: string, cartId: string, address: Address | null): Observable<Cart> {
    const url = this.#occEndpointService.buildUrl('setDeliveryAddress', {
      urlParams: { userId, cartId }
    });
    return this.#httpClient.put<Cart>(url, address);
  }
}
